<template>
  <div class="flex justify-between items-center px-4 py-2 bg-primary-100 rounded-t-xl text-sm">
    <span> {{ actionsHeader }}</span>
    <button
      type="button"
      class="font-bold"
      :disabled="!isConditionsPartiallyFilled"
      :class="{
        'text-main': !isFullLogicShown && isConditionsPartiallyFilled,
        'text-base-content-100': isFullLogicShown || !isConditionsPartiallyFilled,
      }"
      @click="$emit('click')"
    >
      {{ $t("components.workflow.view_logic") }}
    </button>
  </div>
</template>

<script>
import { getConditionsModelString } from "./utils.js";

export default {
  name: "ActionsHeader",

  props: {
    conditions: {
      type: Object,
      required: true,
    },
    isConditionsPartiallyFilled: {
      type: Boolean,
      default: false,
    },
    isFullLogicShown: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    actionsHeader() {
      return this.isFullLogicShown
        ? `${this.selectedConditions} ${this.$t("components.workflow.then_perform_the_actions")}`
        : this.$t("components.workflow.then_perform_the_following");
    },
    selectedConditions() {
      let resultString = "";
      const baseString =`${this.$t('components.workflow.if')} (${getConditionsModelString(
        this.conditions.blocks[0].model,
        this.conditions.blocks[0].operator.main,
      )}) is ${this.conditions.blocks[0].operator.additional}`;

      if (this.conditions.blocks.length > 1) {
        const additionalString = `${this.conditions.operator.main.toUpperCase()} (${getConditionsModelString(
          this.conditions.blocks[1].model,
          this.conditions.blocks[1].operator.main,
          this.conditions.blocks[0].model.length
        )}) is ${this.conditions.blocks[1].operator.additional}, `;

        return resultString.concat(baseString).concat(" ").concat(additionalString);
      }

      return resultString.concat(baseString);
    },
  },
};
</script>
